/**
 * Shared list density + zebra tokens (Jason UI lists Phase 5).
 *
 * Modular = density. Pipeline = zebra/hover.
 * Default, Outreach, Inbox, and Activity tables use these tokens.
 * The admin campaigns list stays on compactListTokens.
 */

/** Status chip shared by Inbox and Activity so both tabs use the same size. */
export const listStatusChip =
  'inline-flex shrink-0 items-center rounded px-1.5 py-0 text-[10px] font-medium leading-4 whitespace-nowrap';

export const modularTable = 'w-full table-fixed divide-y divide-neutral-100';

export const modularThead = 'bg-neutral-50/80';

export const modularTbody = 'divide-y divide-neutral-50 bg-white';

export const modularTh =
  'overflow-hidden px-1.5 py-1.5 text-left text-[10px] font-semibold text-neutral-500 uppercase tracking-wider whitespace-nowrap';

export const modularTd = 'overflow-hidden px-1.5 py-1';

/** Owner column only: centre the 24px circle under the header. Own string so text-center is not fighting modularTh text-left. */
export const ownerColumnTh =
  'overflow-hidden px-1.5 py-1.5 text-center text-[10px] font-semibold text-neutral-500 uppercase tracking-wider whitespace-nowrap';

export const ownerColumnTd = 'overflow-hidden px-1.5 py-1 text-center';

/** Date and percentage columns: own string so text-center does not fight modularTh text-left. */
export const modularThCenter =
  'overflow-hidden px-1.5 py-1.5 text-center text-[10px] font-semibold text-neutral-500 uppercase tracking-wider whitespace-nowrap';

export const modularTdCenter = 'overflow-hidden px-1.5 py-1 text-center';

export const modularRowHover = 'hover:bg-primary-500/[0.06]';

export const modularNameText = 'text-[12px]';

export const modularBodyText = 'text-[11px]';

export const pipelineTableDivide = 'divide-y divide-gray-200';

export const pipelineTbody = 'bg-white divide-y divide-gray-200';

export const pipelineRowHover = 'hover:bg-slate-50/70';

export const pipelineRowZebra = 'even:bg-slate-50/40';

/** Explicit fill for CSS-grid rows (even: is wrong when a header sibling exists). */
export const pipelineZebraFill = 'bg-slate-50/40';

export const pipelineRowLost = 'opacity-70 bg-gray-50';

export const pipelineRowInteractive =
  'cursor-pointer transition-colors duration-150 hover:bg-slate-50/70';

export const modularZebraRow = `${pipelineRowZebra} ${modularRowHover}`;

export const pipelineZebraHoverRow = `${pipelineRowZebra} ${pipelineRowHover}`;

/** Row action control: hidden at rest, visible on row hover or keyboard focus. */
export const rowHoverRevealControl =
  'opacity-0 transition-opacity group-hover:opacity-100 focus-visible:opacity-100';
